namespace('compass.demographic');


compass.demographic.PasswordWidget = compass.defineWidget(function PasswordWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	
	/* Regex breakdown
		^ = Start at the beginning of the string
		(?=.*[a-zA-Z]) = Find any characters, followed by any alpha character, but don't 'consume' any characters
		(?=.*[0-9]) = Same as above, but with number
		(?=.*[^a-zA-Z0-9]) = Same as above, but with any character NOT caught by any of the above. This basically means a 'symbol', but it could easily be changed to a specific list
		(.+)$ = Greedily capture the entire string all the way to the end

		Effectively all the positive lookaheads, the (?=) syntax, are just a list of requirements, and all have to be met to match the regex
	*/
	var _PW_REGEX = '^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(.+)$';
	var _validator = options.validator;

	var _id = [compass.generateId(), compass.generateId()];

	var _labels = {
		password1: {
			label: 'Create Password',
			hint: 'Password must be 8 or more characters, and include at least one letter, one number, and one special character (!, @, #, etc)'
		},
		password2: {
			label:'Confirm Password',
			hint: 'Passwords must be the same'
		}
	};

	var _setupControls = this.setupControls = function() {

	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		var p1 = me.drawPassword1();
		var p2 = me.drawPassword2();
		widgetElem.append(
			p1,
			p2
		);

		if (_validator) {
			_validator.addFields([p1.find('input'), p2.find('input')],
					[_validator.MATCHING, function (fields, opts) {
						if (jQuery(fields[0]).val().length > 5) {
							return _validator.VALID;
						}
						return _validator.INVALID;
					}, function(fields, opts){
						var password1Val = jQuery(fields[0]).val();
						var containsLowerCase = password1Val.match(/[a-z]/);
						var containsUpperCase = password1Val.match(/[A-Z]/);
						if (containsLowerCase || containsUpperCase) {
							return _validator.VALID;
						}
						return _validator.INVALID;
					}], { });
		}

		_setupControls();
	};

	var _grabValues = this.grabValues = function() {
		var values = me.find('.password1Input').serializeArray();
		var jsonValues = {};
		jQuery.each(values, function(i, field) {
			jsonValues[field.name] = field.value;
		});


		return jsonValues;
	};

	this.drawPassword1 = function() {
		var d = _d;
		return d.fieldLabelPair({
			className : 'password1',
			label : _labels.password1.label
		}, [d.input({
			name : 'password1',
			type : 'password',
			id: _id[0],
			'tabindex': '0',
			className : 'password1 password1Input',
			'data-parsley-pattern': _PW_REGEX,
			'data-parsley-required': 'true',
			'data-parsley-minlength': '8',
			'data-parsley-error-message': _labels.password1.hint,
		}).data("hint", _labels.password1.hint)]);
	};

	this.drawPassword2 = function() {
		var d = _d;
		return d.fieldLabelPair({
			className : 'password2',
			label : _labels.password2.label
		}, [d.input({
			name : 'password2',
			type : 'password',
			className : 'password2 password2Input',
			'tabindex': '0',
			id: _id[1],
			'data-parsley-pattern': _PW_REGEX,
			'data-parsley-required': 'true',
			'data-parsley-minlength': '8',
			'data-parsley-equalto' : "#" + _id[0],
			'data-parsley-error-message' : _labels.password2.hint,
		}).data("hint", _labels.password2.hint)]);
	};

	this.checkPasswordsAreSame = function() {
		if(me.find('.password1Input')[0].value == me.find('.password2Input')[0].value) {
			return true;
		} else {
			me.raiseError();
			return false;
		}
	};

	this.raiseError = function() {

	};

	this.drawInstructionBlock = function(text) {
		var d = _d;
		return d.div({
			className : 'passwordInstruction'
		}, text);
	};

	this.drawEndingDiv = function() {
		var d = _d;
		return d.div({
			className : 'endPasswordWidget'
		});
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultPasswordWidgetWUID',
	widgetName : 'PasswordWidget',
	instructionText : 'Set the password you will use to log in and manage your reservation. <br />Passwords must be 6-20 characters.',
	placeholder1 : '',
	placehoder2 : ''
});
